export enum InViewportDirection {
  BOTH = 'both',
  VERTICAL = 'vertical',
  HORIZONTAL = 'horizontal',
}
